import { observer } from 'mobx-react';
import { OrbitComponent } from '../base-components/orbit-component/orbit-component';
import { ITooltipViewModel, TooltipTypeEnum } from "../../services/tooltip/tooltip-base/tooltip-view-model.interface";
import { ITooltipsProvider } from "../../services/tooltip/tooltips-provider.interface";
import { GenericToolTipComponent } from './tooltips/generic-tooltip/generic-tooltip.component';
import { BubbleTooltipComponent } from './tooltips/bubble-tooltip/bubble-tooltip.component';

interface ToolTipContainerComponentProps {
    toolTipsProvider: () => ITooltipsProvider;
}

@observer
export class ToolTipContainerComponent extends OrbitComponent<ToolTipContainerComponentProps> {
    private renderOneTooltip = (tooltip: ITooltipViewModel) => {
        if (tooltip.tooltipType === TooltipTypeEnum.Bubble) {
            return <BubbleTooltipComponent key={tooltip.id} toolTip={tooltip} />
        }

        return <GenericToolTipComponent key={tooltip.id} toolTip={tooltip} />
    }

    render() {
        const toolTips = this.props.toolTipsProvider().toolTips;
        return (
            <>
                {toolTips.map(this.renderOneTooltip)}
            </>
        )
    }
}